import { render, staticRenderFns } from "./KeyValueChip.vue?vue&type=template&id=0feabebe&scoped=true"
import script from "./KeyValueChip.vue?vue&type=script&lang=ts"
export * from "./KeyValueChip.vue?vue&type=script&lang=ts"
import style0 from "./KeyValueChip.vue?vue&type=style&index=0&id=0feabebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0feabebe",
  null
  
)

export default component.exports